/**
 * FolderManager class handles folder navigation and visible nodes calculation
 */
class FolderManager {
  /**
   * Handle folder click - change scope
   * @param {Object} node - Folder node object
   * @returns {string|null} - New currentFolderId or null if invalid
   */
  onFolderClick(node) {
    if (node.type !== 'folder') return null;
    return node.id;
  }

  /**
   * Get visible nodes based on current folder
   * @param {Array} rootTree - Root tree structure
   * @param {string} currentFolderId - Current folder ID
   * @param {Function} findNodeById - Function to find node by id
   * @returns {Array} - Array of visible nodes
   */
  getVisibleNodes(rootTree, currentFolderId, findNodeById) {
    const currentFolder = currentFolderId ? findNodeById(rootTree, currentFolderId) : null;
    return currentFolder?.children ?? (currentFolderId === '' ? rootTree : []);
  }

  /**
   * Get current folder
   * @param {Array} rootTree - Root tree structure
   * @param {string} currentFolderId - Current folder ID
   * @param {Function} findNodeById - Function to find node by id
   * @returns {Object|null} - Current folder node or null
   */
  getCurrentFolder(rootTree, currentFolderId, findNodeById) {
    return currentFolderId ? findNodeById(rootTree, currentFolderId) : null;
  }
}

export default FolderManager;
